module.exports = __webpack_public_path__ + "assets/img/driver-btn-b786af0d.png";